import * as _ from 'lodash';
import { PageBase, PageOptionsBase } from '../../Common/PageBase';
import { DatatableApi, Datatable, DatatableOptions } from '../../Widgets/Datatable'
import { DateUtils } from '../../Utils/DateUtils';

var tableId = 'tableGameTransactions';
var tableDom = "<'row'<'col-sm-6'><'col-sm-6'>>" + "<'row'<'col-sm-12'tr>>" + "<'row'<'col-sm-5'i><'col-sm-7'p>>";

export interface WinPageOptions extends PageOptionsBase {
    urlList: string;
}

export class Win extends PageBase<WinPageOptions> {
    private _tableOptions: DatatableOptions;
    private _table: Datatable;

    constructor(options: WinPageOptions) {
        super(options);

        // === prepare table options
        this._tableOptions = {
            url: this._options.urlList,
            dom: tableDom,
            rowId: 'Id',
            autoWidth: true,
            columns: [
                {
                    data: 'Type',
                    render: (data: any, type: any, rowData: any) =>
                        (`<span id='spnType${rowData.Id}'>${data}</span>`)
                },
                {
                    data: 'Id',
                    className: "bold",
                    render: (data: any, type: any, rowData: any) =>
                        (`<span id='spnName${rowData.Id}'>${data}</a>`)
                },
                {
                    data: 'ExternalParentId',
                    sortable: false,
                    render: (data: any, type: any, rowData: any) =>
                        (`<span id='spnExternalParentId${rowData.Id}'>${data}</a>`)
                },
                {
                    data: 'ReversedBy',
                    render: (data: any, type: any, rowData: any) =>
                        (`<span id='spnReversedBy${rowData.Id}'>${data || ''}</span>`),
                },
                {
                    data: 'RealAmount',
                    render: (data: any, type: any, rowData: any) =>
                        (`<span id='spnRealAmount${rowData.Id}'>${data}</span>`)
                },
                {
                    data: 'BonusAmount',
                    render: (data: any, type: any, rowData: any) =>
                        (`<span id='spnBonusAmount${rowData.Id}'>${data}</span>`)
                },
                {
                    data: 'Status',
                    render: (data: any, type: any, rowData: any) =>
                        (`<span id='spnStatus${rowData.Id}'>${data}</span>`)
                },
                {
                    data: 'Forced',
                    render: (data: any, type: any, rowData: any) =>
                        (`<span id='spnForced${rowData.Id}'>${data}</span>`)
                },
                {
                    data: 'Created',
                    render: (data: any, type: any, rowData: any) =>
                        (`<span id='spnCreated${rowData.Id}'>${DateUtils.toDefaultWithTime(data)}</span>`)
                },
                {
                    data: 'Completed',
                    render: (data: any, type: any, rowData: any) =>
                        (`<span id='spnCompleted${rowData.Id}'>${DateUtils.toDefaultWithTime(data)}</span>`)
                },
                {
                    data: 'RemoteId',
                    render: (data: any, type: any, rowData: any) =>
                        (`<span id='spnRemoteId${rowData.Id}'>${data || ''}</span>`)
                },
                {
                    data: 'RealBalance',
                    render: (data: any, type: any, rowData: any) =>
                        (`<span id='spnRealBalance${rowData.Id}'>${data}</span>`)
                },
                {
                    data: 'BonusBalance',
                    render: (data: any, type: any, rowData: any) =>
                        (`<span id='spnBonusBalance${rowData.Id}'>${data}</span>`)
                }
            ],
            order: [[1, "asc"]]
        };
    }

    init(): void {
        // == create 'new Datatable' instance
        this._table = new Datatable(tableId, this._tableOptions);
    }
}


/** WEBPACK FOOTER **
 ** ./Typescript/Pages/ProgressiveBonuses/Win.ts
 **/